var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: "Sincronizar processo", width: 500 },
      on: { closeModal: _vm.cancelar }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c("app-label", {
                    attrs: {
                      label:
                        "Informe o número do recibo indicado no comprovante de envio do seu cadastro para o acompanhamento do processo.",
                      required: false
                    }
                  }),
                  _c(
                    "validation-observer",
                    { ref: "observer", attrs: { tag: "form" } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: "Protocolo",
                          mode: "lazy"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: { label: "Número do recibo:" }
                                }),
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: _vm.protocoloMask,
                                      expression: "protocoloMask"
                                    }
                                  ],
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: {
                                    name: "Protocolo",
                                    placeholder: "XXXXXX-XXXXXXX-0000"
                                  },
                                  model: {
                                    value: _vm.protocolo,
                                    callback: function($$v) {
                                      _vm.protocolo =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "protocolo"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "el-button",
              { staticClass: "cancelarButton", on: { click: _vm.cancelar } },
              [
                _c("i", { staticClass: "fas fa-times" }),
                _c("span", [_vm._v("   Cancelar")])
              ]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.vincularUsuarioProcesso }
              },
              [
                _c("i", { staticClass: "fas fa-check" }),
                _c("span", [_vm._v("  Confirmar")])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05741041", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05741041","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/processos/SincronizarProcesso.vue
// module id = null
// module chunks = 